import type { Security, TransformOptions } from "filestack-js";
import type React from "react";
import { useMemo } from "react";
import { createFilestackClient } from "../config/filestack";
import { FileStackContext } from "../hooks/useFileStackContext";
import { getUrl, isUrl } from "../utils/filestack";

interface FileStackProviderProps {
  apiKey?: string;
  security?: Security;
  children: React.ReactNode;
}

export const FileStackProvider: React.FC<FileStackProviderProps> = ({
  apiKey,
  security,
  children,
}) => {
  const filestack = useMemo(() => createFilestackClient(apiKey, { security }), [apiKey, security]);

  const getFileStackUrl = (fileStackHandle: string, options?: TransformOptions): string | null => {
    if (!fileStackHandle) return null;

    const cantTransform = !fileStackHandle || !security?.policy || !security?.signature;
    if (cantTransform) {
      return "";
    }

    if (isUrl(fileStackHandle)) {
      const url = fileStackHandle;

      if (options) {
        return filestack.transform(encodeURIComponent(url), options);
      }

      return url;
    }

    return getUrl(fileStackHandle, security, apiKey, options);
  };

  return (
    <FileStackContext.Provider value={{ filestack, getFileStackUrl, security }}>
      {children}
    </FileStackContext.Provider>
  );
};
